"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWrapper = exports.UserMenuWrapper = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = __importDefault(require("../../Button/Button"));
var Variables_1 = require("../../Variables");
var ChevronLeft_1 = __importDefault(require("../../Icon/icons/ChevronLeft"));
var Flex_1 = __importDefault(require("../../Flex/Flex"));
var useWindowSize_1 = require("../../Hooks/useWindowSize");
var ContentToggle_1 = __importDefault(require("../../ContentToggle/ContentToggle"));
var MobileMenuHeader_1 = __importDefault(require("../../MobileMenuHeader/MobileMenuHeader"));
var UserDetails_1 = __importDefault(require("../../UserDetails/UserDetails"));
exports.UserMenuWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  box-sizing: border-box;\n  top: 100%;\n  width: 250px;\n  ", "\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  box-sizing: border-box;\n  top: 100%;\n  width: 250px;\n  ", "\n"])), Variables_1.color.BRAND_WHITE, Variables_1.color.BRAND_PREMIUM_GREY, function (props) {
    return props.$isMobile &&
        "\n    border: none;\n    border-radius: 0;\n    height: 100vh;\n    margin-right: -100vw;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: margin-right 0.25s ease-in-out;\n    width: 100vw;\n    margin-right: ".concat(props.$open ? "0" : "-100vw", ";    \n  ");
});
exports.ButtonWrapper = (0, styled_components_1.default)(Flex_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  > button {\n    margin: 4px 0;\n    text-align: left;\n    &:first-child {\n      margin-top: 0;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  padding: ", ";\n  > button {\n    margin: 4px 0;\n    text-align: left;\n    &:first-child {\n      margin-top: 0;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"])), Variables_1.padding.XS);
var PageWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh;\n"], ["\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh;\n"])));
var ContentWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow-y: auto;\n"], ["\n  overflow-y: auto;\n"])));
var UserMenu = function (_a) {
    var backLabel = _a.backLabel, onClose = _a.onClose, menuItems = _a.menuItems, mobileTitle = _a.mobileTitle, _b = _a.user, user = _b === void 0 ? { firstName: '', lastName: '' } : _b;
    var isMobile = (0, useWindowSize_1.useIsMobile)();
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    React.useEffect(function () {
        if (!open)
            setOpen(true);
    }, []);
    var AnimateBeforeClose = function () {
        setOpen(false);
        var lastTime;
        requestAnimationFrame(function animation(time) {
            if (!lastTime)
                lastTime = time;
            if (time - lastTime < 250) {
                requestAnimationFrame(animation);
                return;
            }
            onClose === null || onClose === void 0 ? void 0 : onClose();
        });
    };
    return (React.createElement(exports.UserMenuWrapper, { "$open": open, "$isMobile": isMobile },
        React.createElement(ContentToggle_1.default, null, function (toggleBack, toggleNext) { return (React.createElement(PageWrapper, null,
            isMobile && React.createElement(MobileMenuHeader_1.default, { onCloseClick: AnimateBeforeClose, title: mobileTitle }),
            React.createElement(ContentWrapper, null,
                React.createElement(UserDetails_1.default, { firstName: user.firstName, lastName: user.lastName }),
                React.createElement(exports.ButtonWrapper, { direction: "column" }, menuItems === null || menuItems === void 0 ? void 0 : menuItems(onClose).map(function (menuItem, key) {
                    var component = menuItem.component, altContent = menuItem.altContent, hidden = menuItem.hidden, icon = menuItem.icon, label = menuItem.label, clickHandler = menuItem.clickHandler;
                    if (hidden)
                        return null;
                    return (React.createElement(Button_1.default, { ghost: true, icon: icon, key: key, xs: true, onClick: component
                            ? function () {
                                return toggleNext(React.createElement(React.Fragment, null,
                                    isMobile ? (React.createElement(MobileMenuHeader_1.default, { color: "BRAND_BLACK", onBackClick: toggleBack, onCloseClick: AnimateBeforeClose, title: label })) : (React.createElement(Button_1.default, { ghost: true, xs: true, icon: React.createElement(ChevronLeft_1.default, null), onClick: toggleBack }, backLabel)),
                                    component));
                            }
                            : clickHandler }, altContent ? altContent : label));
                }))))); })));
};
exports.default = UserMenu;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
